export default __webpack_public_path__ + "9be1aa0888cdbbecebbe7e7c98cf0925.svg";